import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000"
    height="24"
    width="24"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'bottom', stroke: 'currentColor' }}
  >
    <path d="M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.58-4.6 4.58-4.6z" fill="#0066cc" />
  </svg>
);
